// BUG: Critical vulnerability. Anyone can guess the private key by the public Telegram ID.
export const generateDeterministicPrivateKey = async (userId: number) => {
  const encoder = new window.TextEncoder();
  const userIdBytes = encoder.encode(userId.toString());
  const hash = await crypto.subtle.digest("SHA-256", userIdBytes);
  return new Uint8Array(hash);
};
